import { useTheme } from "../context/ThemeContext";

// Aeroplay logos (already in the project)
const AEROPLAY_DARK = "https://customer-assets.emergentagent.com/job_24108f3e-b858-4890-993f-f1e1a60b89e6/artifacts/h1sxdkcz_Aeroplay%20logo%202026_White.png";
const AEROPLAY_LIGHT = "https://customer-assets.emergentagent.com/job_24108f3e-b858-4890-993f-f1e1a60b89e6/artifacts/oot4cqoo_Aeroplay%20logo%202026_Black.png";

// Group brand logos — negative versions (white on black bg)
// In dark mode: show as-is. In light mode: apply CSS invert.
const groupBrands = [
  { name: "Aeroplay", logoDark: AEROPLAY_DARK, logoLight: AEROPLAY_LIGHT, hasLightVersion: true },
  { name: "Silk Route Entertainment", logoDark: "/assets/Silk_Route_Negative.png" },
  { name: "Neutral", logoDark: "/assets/Neutral_Negative.png" },
  { name: "Maxposure", logoDark: "/assets/Maxposure_Negative.png" },
  { name: "AeroHub", logoDark: "/assets/Aerohub_Negative.png" },
  { name: "APX Luxury", logoDark: "https://customer-assets.emergentagent.com/job_24108f3e-b858-4890-993f-f1e1a60b89e6/artifacts/vexnnnll_buradaluxury-white.png", heightScale: 0.56 },
  { name: "Alpha Pictures", logoDark: "/assets/Alpha_Negative.png" },
];

const BrandCarousel = () => {
  const { isDark } = useTheme();

  // Duplicate for seamless loop
  const brands = [...groupBrands, ...groupBrands];

  return (
    <div data-testid="brand-carousel">
      <div className={`text-[10px] uppercase tracking-wider font-semibold mb-3 text-center ${
        isDark ? "text-slate-500" : "text-slate-400"
      }`}>
        Our Group
      </div>
      <div className="relative overflow-hidden">
        {/* Fade edges */}
        <div className={`absolute left-0 top-0 bottom-0 w-16 z-10 pointer-events-none ${
          isDark
            ? "bg-gradient-to-r from-slate-950 to-transparent"
            : "bg-gradient-to-r from-slate-100 to-transparent"
        }`} />
        <div className={`absolute right-0 top-0 bottom-0 w-16 z-10 pointer-events-none ${
          isDark
            ? "bg-gradient-to-l from-slate-950 to-transparent"
            : "bg-gradient-to-l from-slate-100 to-transparent"
        }`} />

        {/* Scrolling track */}
        <div className="flex items-center gap-12 animate-brand-scroll">
          {brands.map((brand, idx) => (
            <div
              key={`${brand.name}-${idx}`}
              className="flex-shrink-0 flex items-center justify-center h-12"
            >
              {brand.hasLightVersion ? (
                <img
                  src={isDark ? brand.logoDark : brand.logoLight}
                  alt={brand.name}
                  className="w-auto object-contain opacity-70 hover:opacity-100 transition-opacity"
                  style={{ height: `${(brand.heightScale || 1) * 40}px` }}
                />
              ) : (
                <img
                  src={brand.logoDark}
                  alt={brand.name}
                  className={`w-auto object-contain opacity-70 hover:opacity-100 transition-opacity ${
                    !isDark ? "invert" : ""
                  }`}
                  style={{ height: `${(brand.heightScale || 1) * 40}px` }}
                />
              )}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes brandScroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-brand-scroll {
          animation: brandScroll 25s linear infinite;
        }
        .animate-brand-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </div>
  );
};

export default BrandCarousel;
